import { createContext, useContext } from 'react';
import { MunicipalityKey } from '../Hooks/Municipality';
export const MunicipalityContext = createContext<MunicipalityKey>({ name: '', number: 0});

export function useMunicipality() {
  const context = useContext(MunicipalityContext);

  if (context === undefined) {
    throw new Error(
      "useMunicipality must be used within a MunicipalityContext"
    );
  }

  if (context.number <= 0){
    throw new Error(
      "Municipality not set correctly"
    )
  }

  return context;
}